"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var ButtonPrimary_1 = __importDefault(require("atomicComponents/atoms/Buttons/ButtonPrimary"));
var backend_1 = require("utils/backend");
// import { download } from 'utils/fieldProcessors';
var utils_1 = require("utils/selectors/utils");
var DebugPath_1 = __importDefault(require("./DebugPath"));
var DebugQueries_1 = __importDefault(require("./DebugQueries"));
var selectSalesforceConnections = (0, utils_1.makeSelectOrdered)('salesforceConnections');
var DebugSalesforce = function () {
    var _a = __read(react_1.default.useState(''), 2), connId = _a[0], setConnId = _a[1];
    var _b = __read(react_1.default.useState(true), 2), testQuery = _b[0], setTestQuery = _b[1];
    var _c = __read(react_1.default.useState(null), 2), resp = _c[0], setResp = _c[1];
    var _d = __read(react_1.default.useState(null), 2), jsonUrl = _d[0], setJsonUrl = _d[1];
    window.sfResp = resp;
    var _e = __read((0, backend_1.useCall)('transactions-salesforce-testSalesforce'), 1), callTestSalesforce = _e[0];
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        { collection: 'integration_connections', storeAs: 'salesforceConnections', where: ['provider', '==', 'Salesforce'] },
    ]; });
    var allSalesforceConnections = (0, react_redux_1.useSelector)(selectSalesforceConnections);
    var salesforceConnections = allSalesforceConnections === null || allSalesforceConnections === void 0 ? void 0 : allSalesforceConnections.filter(end2end_1.isIntConnVisible);
    var Form = testQuery ? DebugQueries_1.default : DebugPath_1.default;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: 500 }, { children: (0, jsx_runtime_1.jsxs)("label", { children: ["Connection", !(0, react_redux_firebase_1.isLoaded)(salesforceConnections) && '(Loading...)', ":", (0, jsx_runtime_1.jsxs)("select", __assign({ onChange: function (e) { return setConnId(e.target.value); } }, { children: [(0, jsx_runtime_1.jsx)("option", __assign({ value: "" }, { children: "NONE" })), salesforceConnections === null || salesforceConnections === void 0 ? void 0 : salesforceConnections.map(function (c) { return ((0, jsx_runtime_1.jsxs)("option", __assign({ value: c.id }, { children: [c.accUserEmail, !(0, end2end_1.isIntConnActive)(c) && ' (Disconnected)'] }), c.id)); })] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex" }, { children: [(0, jsx_runtime_1.jsx)(ButtonPrimary_1.default, __assign({ disabled: testQuery, onClick: function () { return setTestQuery(true); } }, { children: "Test Query" })), (0, jsx_runtime_1.jsx)(ButtonPrimary_1.default, __assign({ disabled: !testQuery, onClick: function () { return setTestQuery(false); } }, { children: "Test Path" }))] }))] }) })), connId && ((0, jsx_runtime_1.jsx)(Form, { testSalesforce: function (v) { return callTestSalesforce(__assign({ connId: connId }, v))().then(function (r) {
                    setResp(r === null || r === void 0 ? void 0 : r.data);
                    setJsonUrl(r === null || r === void 0 ? void 0 : r.data.jsonUrl);
                }); } })), jsonUrl && (0, jsx_runtime_1.jsx)("a", __assign({ href: jsonUrl, target: "_blank" }, { children: "Download JSON Here" })), resp && (0, jsx_runtime_1.jsx)("pre", { children: JSON.stringify(resp, null, 2) })] }));
};
exports.default = DebugSalesforce;
